import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectReportsRoutes = [
  {
    path: 'reports',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Reports')
      },
      permissions: ['READ_REPORTS']
    },
    children: [
      {
        path: '',
        name: 'reportsList',
        component: wrapLegacyRoute('reportsController', 'list')
      },
      {
        path: 'create',
        name: 'reportCreate',
        component: wrapLegacyRoute('reportsController', 'create')
      },
      {
        path: ':reportId(\\d+)',
        name: 'reportDetails',
        component: wrapLegacyRoute('reportsController', 'details')
      },
      {
        path: 'schedules',
        name: 'reportScheduleList',
        component: wrapLegacyRoute('reportsController', 'schedules')
      },
      {
        path: ':reportId(\\d+)/schedules/create',
        name: 'createReportSchedule',
        component: wrapLegacyRoute('reportsController', 'createSchedule')
      },
      {
        path: 'schedules/:scheduleId(\\d+)',
        name: 'reportSchedule',
        component: wrapLegacyRoute('reportsController', 'schedule')
      }
    ]
  }
];

export default projectReportsRoutes;
